import { CommonModule } from '@angular/common';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { LoaderComponent } from "../../shared/loader/loader.component";
import { TranslateModule } from '@ngx-translate/core';

import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, LoaderComponent, TranslateModule, RouterLink],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit, AfterViewInit {

  schoolNames: string[] = [];
  isLoading = true;

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    // Laisser Angular afficher le loader avant de charger les données
    setTimeout(() => {
      const studentList = JSON.parse(localStorage.getItem('studentList') || '[]');

      if (studentList.length > 0) {
        this.schoolNames = Array.from(new Set(
          studentList.map((student: { nameOrg: any; }) => student.nameOrg || 'Non défini')
        ));
      }
      this.isLoading = false;
    }, 200); // 200ms pour que le loader soit visible
  }

}
